import { createFileRoute, useParams } from '@tanstack/react-router';

import { AssessmentsTab } from '@/views/admin/courses/tabs/assessments-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/assessments')({
  component: AssessmentsRoute,
});

function AssessmentsRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/assessments' });
  return <AssessmentsTab id={id} />;
}
